var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.882812,
    width: 29.2883,
    height: 29.2886,
    fill: "url(#pattern0_394_1813)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_394_1813",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_394_1813",
    transform: "scale(0.00781256)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_394_1813",
    width: 128,
    height: 128,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAA8RJREFUeJzt3b9rlWcYxvHv3Ub6g6pQHULoD+3gIC5WrIsaBHEotPgHFDpJhQ6F/gEOUujs4OLiIILQrUMLXRyaQsFJcJBWFAq2ES0aKNGicnfwFBSUxnqe937Pc10fCCSQPM99cr55zyF5kgT2TJm5AHwAvA9sAbYC88CbwBywYfKu94G/HvvQf99eAVYnL3eA28AN4BZwE/hj8vqViLjX9tY8XVRsOlaZuQ5YBA4DHwHvDLT1vohYGmivJ8xVbDo2mTkPfAp8DrxdPM6gpAPIzM3AMeAosK54nBKSAWRm8Oir/StgY/E4peQCmDyxOw0cqp5lDKQCyMwdwPfAW9WzjMVL1QMMJTMPAD/hO/8JEleAzNwNfAu8UT3L2HR/BcjMbcB3+M5/qq4DyMxXgHPA5upZxqrrAICvgZ3VQ4xZtwFk5k7gi+o5xq7bAIAT9H37pqLLT1Bmfgzsq55jFnQZAPBl9QCzorsAJt/t2189x6zoLgDgCD7nsGZdBTD5Kd/h6jlmSVcBALsY7hRPF3oL4GD1ALOmtx8G7Rl4v4fARWAJ+IVHBz9XgOc94HlpynNpyszrOYzbmXk8MzdV3+YX1c2z5cn5vpsDbHUR+DAifh9gr+Z6egjYMsAevwKLEbEywF6D6OlJ4LuN10/gs57ufOgrgNbn+S9ExPnGewyupwDWN17/m8brl+gpgNcbr/9z4/VL9BTAa43Xv9x4/RI9BdDyV7seRMSthuuX6SmAllarB2jFAazN39UDtOIA1iarB2jFAYhzAOIcgDgHIM4BiHMA4hyAOAcgzgGIcwDiHIA4ByCu7FRwZr4KLExxyQ3//S7/28uZ+V6jtf+sPGha9nsBmbkX+LFq/xH5JCLOVm3uh4B61yo3dwD1HICwe8By5QAOoNa1iCg9beQAapVe/sEBVHMA4hyAOAcgzgGIcwDCViLiTvUQDqDO1eoBwAFUKr/8gwOo5ADEOQBxfg4gzlcAYQn8Vj0EOIAqyxExij874wBqjOLyDw6gymgCqPxj0cvAqSmutxfYPsX1HncXODPF9X6Y4loGkJknG/5/gBvVt68VPwSIcwDiHIA4ByDOAYhzAOIcgDgHIM4BiHMA4hyAOAcgzgGIcwDiHIA4ByDOAYhzAOIcgDgHIM4BiHMA4hyAOAcgzgGIcwDiHIA4ByDOAYhzAOIcgDgHIM4BiHMA4hyAOAcgzgGIcwDiHIA4ByDOAYhzAOIcgDgHIM4BiHMA4hyAOAcgzgGIcwDiHIA4ByDOAYhzAOIcgDgHIM4BiPsHiGNiEj3qU8AAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d77715a2bb73236180776cee350544f5.svg";
export { ForwardRef as ReactComponent };